import clsx from 'clsx';
import React from 'react';

type FieldWrapperProps = {
  children: React.ReactNode;
  className?: string;
  label?: React.ReactNode;
  labelPosition?: 'top' | 'left' | 'right';
};

const FormLabel = ({
  children,
  className,
  htmlFor,
}: {
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
}) => (
  <label
    htmlFor={htmlFor}
    className={clsx('text-sm font-medium text-gray-700', className)}
  >
    {children}
  </label>
);

export const FieldWrapper = ({
  label,
  className,
  children,
  labelPosition = 'top',
}: FieldWrapperProps) => {
  // Top Label
  if (labelPosition === 'top') {
    return (
      <FormLabel className={clsx('block', className)}>
        {label}
        <div className={clsx(label && 'mt-1')}>{children}</div>
      </FormLabel>
    );
  }

  return (
    <FormLabel className={clsx('flex items-center justify-between', className)}>
      {/* Left Label */}
      {labelPosition === 'left' && label && (
        <span className="mr-3 flex-1">{label}</span>
      )}

      {children}

      {/* Right Label */}
      {labelPosition === 'right' && label && (
        <span className="ml-3 flex-1">{label}</span>
      )}
    </FormLabel>
  );
};
